/**
 * axios封装
 * 请求拦截、相应拦截、错误统一处理
 */

import axios from 'axios';
import QS from 'qs';
import { Notification } from 'element-ui';
import { loginFail } from 'util/assit';
import router from '../router';

// 环境的切换
axios.defaults.baseURL = process.env.NODE_ENV === 'production' ? process.env.VUE_APP_API_BASE_URL : '/';

// 请求超时时间10s
axios.defaults.timeout = 10000;

// post请求头
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

// 跨域携带cookie
axios.defaults.withCredentials = true;

// 响应拦截器
axios.interceptors.response.use(
  (response) => {
    if (response.status === 200) {
      if (response.data.message === '用户未登录'
        && (router.currentRoute.fullPath.match(/\/userCenter\//)
          || ['require', 'product'].includes(router.currentRoute.name || ''))) {
        loginFail();
      } else {
        return Promise.resolve(response);
      }
    }
    return Promise.reject(response);
  },
  // 服务器状态码不是200的情况
  (error) => {
    if (error.response.status) {
      switch (error.response.status) {
        // 401: 未登录
        // 未登录则跳转登录页面，并携带当前页面的路径
        // 在登录成功后返回当前页面，这一步需要在登录页操作。
        case 401:
        case 403:
          if (router.currentRoute.fullPath.match(/\/userCenter\//)
            || ['require', 'product'].includes(router.currentRoute.name || '')) {
            loginFail();
          }
          break;
        case 404:
          Notification.error('请求的资源不存在');
          break;
        // 其他错误，直接抛出错误提示
        default:
          Notification.error(error.response.data.message);
      }
    } else {
      Notification.error('服务未响应，请重试');
    }
    return Promise.reject(error.response);
  },
);

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url: string, params = {}) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params,
    }).then((res) => {
      resolve(res.data);
    }).catch((err) => {
      reject(err.data);
    });
  });
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url: string, params = {}) {
  return new Promise((resolve, reject) => {
    axios.post(url, QS.stringify(params))
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}

/**
 * del，对应delete请求
 * @param {String} url [请求的url地址]
 */
export function del(url: string) {
  return new Promise((resolve, reject) => {
    axios.delete(url)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}
